import React from "react";
import { Link } from "react-router-dom";
import logo1 from "../assets/logo1.jpg";


export default function Header() {
  return (
    <header className="top-header">
      <div className="header-left">
        <Link to="/">
          <img src={logo1} alt="Logo DirectSchoon" className="logo" />
        </Link>
      </div>

      <div className="header-right">
        <div className="contact-row">
          <span className="phone">📞 06 41 41 61 69</span>
          <span className="email">✉️ Stuur ons e-mail</span>
        </div>

        <hr className="divider" />

        <div className="menu-social-row">
          <nav className="nav-menu">
                <a href="#">Zakeljik ▾</a>
                <a href="#">Privé ▾</a>
                <a href="#">Contact ▾</a>
                <a href="#">Werken bij DirectSchoon ▾</a>
          </nav>

          <div className="social-row">
            <a href="#"><i className="fab fa-facebook-f"></i></a>
            <a href="#"><i className="fab fa-instagram"></i></a>
            <a href="#"><i className="fab fa-linkedin-in"></i></a>
            <a href="#"><i className="fab fa-youtube"></i></a>
          </div>
        </div>
      </div>
    </header>
  );
}
